import Cart from '@/generated/classes/Cart';
import { PayboxData } from '@/generated/classes/Carte';
import { CartItem as CartItemBase } from '@/generated/classes/Cart';
import { storeSession } from '@/generated/stores';
import { type AxiosResponse } from 'axios';

export default class CartExtend extends Cart {
  constructor() {
    super();
  }
  public static command(cart: Cart): Promise<Cart | PayboxData> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/carts/command', cart, storeSession.httpAuthor)
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(res.data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
      reject(null);
    });
  }

  public static loadPaybox(data: PayboxData, paymentWindow: Window): void {
    const form = document.createElement("form");
    form.method = "POST";
    form.action = data.payboxUrl;
    paymentWindow.name = paymentWindow.name || `paybox-${Date.now()}`;
    form.target = paymentWindow.name;

    // Ajouter les paramètres
    Object.entries(data.parameters as Record<string, string>).forEach(([key, value]) => {
      const input = document.createElement("input");
      input.type = "hidden";
      input.name = key;
      input.value = value;
      form.appendChild(input);
    });

    // Ajouter la signature
    if (data.signature != '') {
      const sig = document.createElement("input");
      sig.type = "hidden";
      sig.name = "PBX_HMAC";
      sig.value = data.signature;
      form.appendChild(sig);
    }

    document.body.appendChild(form);
    form.submit();
    form.remove();
  }

  public static payWithPaybox(cart: Cart): Promise<void> {
    const paymentWindow = window.open('', '_blank');
    if (!paymentWindow) {
      return Promise.reject(new Error('La fenêtre Paybox a été bloquée par le navigateur.'));
    }

    paymentWindow.document.title = 'Paiement Paybox';
    paymentWindow.document.body.innerHTML = '<p>Chargement du paiement sécurisé…</p>';

    return CartExtend.command(cart)
      .then((data) => {
        if (!CartExtend.isPayboxData(data)) {
          throw new Error('Réponse Paybox invalide.');
        }
        const pbxCmd = (data.parameters as Record<string, string>).PBX_CMD;
        if (!pbxCmd) {
          throw new Error('Référence Paybox absente.');
        }
        const waitForWindow = CartExtend.waitForPayboxWindow(pbxCmd, paymentWindow);
        CartExtend.loadPaybox(data, paymentWindow);
        return waitForWindow;
      })
      .catch((error) => {
        if (!paymentWindow.closed) paymentWindow.close();
        throw error;
      });
  }

  private static isPayboxData(data: Cart | PayboxData): data is PayboxData {
    return !!data &&
      typeof (data as PayboxData).payboxUrl === 'string' &&
      !!(data as PayboxData).parameters;
  }

  private static waitForPayboxWindow(
    pbxCmd: string,
    paymentWindow: Window
  ): Promise<void> {
    return new Promise((resolve) => {
      let closeWatcher = 0;
      let finished = false;
      const cleanup = () => {
        window.clearInterval(closeWatcher);
        window.removeEventListener('message', onPayboxReturn);
      };
      const finish = () => {
        if (finished) return;
        finished = true;
        cleanup();
        resolve();
      };
      const onPayboxReturn = (event: MessageEvent) => {
        if (event.source !== paymentWindow ||
            event.data?.type !== 'paybox-return' ||
            event.data?.pbxCmd !== pbxCmd) {
          return;
        }
        finish();
      };
      window.addEventListener('message', onPayboxReturn);
      closeWatcher = window.setInterval(() => {
        if (!finished && paymentWindow.closed) {
          finish();
        }
      }, 500);
    });
  }
}
export class CartItem extends CartItemBase {
  constructor() {
    super();
  }
}
